import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { AppProviders } from './app/AppProviders';
import { createAppRouter } from './app/routes';

const start = async (): Promise<void> => {
  if (__MOCK_ENABLED__) {
    // ビルド時定数なので、モック無効のビルドではこの分岐(と MSW)が丸ごと除去される
    const { worker } = await import('@kdk/shared/mocks/browser');
    await worker.start({
      onUnhandledFrame: 'bypass',
      serviceWorker: { url: `${import.meta.env.BASE_URL}mockServiceWorker.js` },
    });
  }
  const root = document.getElementById('root');
  if (root === null) throw new Error('#root が見つかりません');
  createRoot(root).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={createAppRouter()} />
      </AppProviders>
    </StrictMode>,
  );
};

start().catch((error: unknown) => {
  const root = document.getElementById('root');
  if (root) {
    root.textContent = `起動に失敗しました: ${error instanceof Error ? error.message : String(error)}`;
  }
});
